/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  authTokenKey: 'payment-web',
  api: {
		host: 'https://api-payment.fft.com.vn/api',
		// host: 'http://localhost:8080/api',
		AppID: 'Mr2n4FaCO8XdS7K6x4sHbIT6L+Gumltq7dy/EW0eIXQ=',
	},
  hostAllow: [
		'https://api-payment.fft.com.vn/api',
		'http://localhost:8080/api',
	],
	version: "v 1.0.0",
};
